export const GET_CAMPAIGNS_REQUEST = 'GET_CAMPAIGNS_REQUEST';
export const GET_CAMPAIGNS_FAILURE = 'GET_CAMPAIGNS_FAILURE';
export const GET_CAMPAIGNS_SUCCESS = 'GET_CAMPAIGNS_SUCCESS';

export const GET_CAMPAIGN_DETAIL_REQUEST = 'GET_CAMPAIGN_DETAIL_REQUEST';
export const GET_CAMPAIGN_DETAIL_FAILURE = 'GET_CAMPAIGN_DETAIL_FAILURE';
export const GET_CAMPAIGN_DETAIL_SUCCESS = 'GET_CAMPAIGN_DETAIL_SUCCESS';

export const CREATE_CAMPAIGN_REQUEST = 'CREATE_CAMPAIGN_REQUEST';
export const CREATE_CAMPAIGN_FAILURE = 'CREATE_CAMPAIGN_FAILURE';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';

export const GET_CAMPAIGN_MESSAGES_REQUEST = 'GET_CAMPAIGN_MESSAGES_REQUEST';
export const GET_CAMPAIGN_MESSAGES_FAILURE = 'GET_CAMPAIGN_MESSAGES_FAILURE';
export const GET_CAMPAIGN_MESSAGES_SUCCESS = 'GET_CAMPAIGN_MESSAGES_SUCCESS';

export const CREATE_CAMPAIGN_MESSAGES_REQUEST = 'GET_CAMPAIGN_MESSAGES_REQUEST';
export const CREATE_CAMPAIGN_MESSAGES_FAILURE = 'GET_CAMPAIGN_MESSAGES_FAILURE';
export const CREATE_CAMPAIGN_MESSAGES_SUCCESS = 'GET_CAMPAIGN_MESSAGES_SUCCESS';

export const CREATE_RANDOM_SELECTION_REQUEST = 'CREATE_RANDOM_SELECTION_REQUEST';
export const CREATE_RANDOM_SELECTION_FAILURE = 'CREATE_RANDOM_SELECTION_FAILURE';
export const CREATE_RANDOM_SELECTION_SUCCESS = 'CREATE_RANDOM_SELECTION_SUCCESS';

export const GET_REPLY_MESSAGES_REQUEST = 'GET_REPLY_MESSAGES_REQUEST';
export const GET_REPLY_MESSAGES_FAILURE = 'GET_REPLY_MESSAGES_FAILURE';
export const GET_REPLY_MESSAGES_SUCCESS = 'GET_REPLY_MESSAGES_SUCCESS';

export const GET_RANDOM_SELECTIONS_REQUEST = 'GET_RANDOM_SELECTIONS_REQUEST';
export const GET_RANDOM_SELECTIONS_FAILURE = 'GET_RANDOM_SELECTIONS_FAILURE';
export const GET_RANDOM_SELECTIONS_SUCCESS = 'GET_RANDOM_SELECTIONS_SUCCESS';

export const SET_RANDOM_SELECTIONS_WINNER_REQUEST = 'SET_RANDOM_SELECTIONS_WINNER_REQUEST';
export const SET_RANDOM_SELECTIONS_WINNER_FAILURE = 'SET_RANDOM_SELECTIONS_WINNER_FAILURE';
export const SET_RANDOM_SELECTIONS_WINNER_SUCCESS = 'SET_RANDOM_SELECTIONS_WINNER_FAILURE';

export const SET_CAMPAIGN_FILTERS = 'SET_CAMPAIGN_FILTERS';
export const SET_CAMPAIGN_PAGE = 'SET_CAMPAIGN_PAGE';



// WEBPACK FOOTER //
// ./src/store/modules/campaign/mutation-types.js